<div class="mydocma-mm-fields-attribute-dropdown-tile">
  <img *ngIf="imageUrl" [src]="imageUrl" class="attribute-image" [alt]="item?.data?.ImageFileName">
  <p>{{item?.text}}</p>
</div>